export class ExtenderDemoPayload {
  dias: number = 15;   // días a sumar a demoFin
}
